import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2331 2331"
      id="vector">
      <g
        id="group"
        transform="translate(194 76)">
        <path
          id="path"
          d="M 293.5 0 L 304 0.5 L 293.5 1 L 293.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 403.5 0 L 413 0.5 L 403.5 1 L 403.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 788.5 0 L 795 0.5 L 788.5 1 L 788.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1807.5 0 L 1814 0.5 L 1807.5 1 L 1807.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 282.5 1 L 287 1.5 L 282.5 2 L 282.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 420.5 1 L 425 1.5 L 420.5 2 L 420.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 781.5 1 L 784 1.5 L 781.5 2 L 781.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 1818.5 1 L 1822 1.5 L 1818.5 2 L 1818.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 273.5 2 L 277 2.5 L 273.5 3 L 273.5 2 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 430.5 2 L 434 2.5 L 430.5 3 L 430.5 2 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 1825.5 2 L 1828 2.5 L 1825.5 3 L 1825.5 2 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 266.5 3 L 269 3.5 L 266.5 4 L 266.5 3 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 437.5 3 L 441 3.5 L 437.5 4 L 437.5 3 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 260.5 4 L 263 4.5 L 260.5 5 L 260.5 4 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 444.5 4 L 447 4.5 L 444.5 5 L 444.5 4 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 254.5 5 L 257 5.5 L 254.5 6 L 254.5 5 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 449.5 5 L 452 5.5 L 449.5 6 L 449.5 5 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 249.5 6 L 252 6.5 L 249.5 7 L 249.5 6 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 459.5 7 L 462 7.5 L 459.5 8 L 459.5 7 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 733.5 17 L 732.5 19 L 733.5 17 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 719.5 26 L 718.5 28 L 719.5 26 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 1884.5 27 L 1885.5 29 L 1884.5 27 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 716.5 28 L 714.5 31 L 716.5 28 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1888.5 30 L 1890.5 33 L 1888.5 30 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 711.5 32 L 708.5 36 L 711.5 32 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1893.5 34 L 1908.5 50 L 1893.5 34 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 704.5 38 L 698.5 45 L 704.5 38 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 311.5 46 L 395 46.5 L 311.5 47 L 311.5 46 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 801.5 46 L 1801 46.5 L 801.5 47 L 801.5 46 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 291.5 47 L 298 47.5 L 291.5 48 L 291.5 47 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 409.5 47 L 415 47.5 L 409.5 48 L 409.5 47 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 558.5 47 L 559.5 49 L 558.5 47 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 789.5 47 L 793 47.5 L 789.5 48 L 789.5 47 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1810.5 47 L 1814 47.5 L 1810.5 48 L 1810.5 47 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 281.5 48 L 286 48.5 L 281.5 49 L 281.5 48 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 421.5 48 L 425 48.5 L 421.5 49 L 421.5 48 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 783.5 48 L 786 48.5 L 783.5 49 L 783.5 48 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 144.5 49 L 143.5 51 L 144.5 49 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 274.5 49 L 278 49.5 L 274.5 50 L 274.5 49 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 429.5 49 L 432 49.5 L 429.5 50 L 429.5 49 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 694.5 49 L 691.5 53 L 694.5 49 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 268.5 50 L 271 50.5 L 268.5 51 L 268.5 50 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 435.5 50 L 438 50.5 L 435.5 51 L 435.5 50 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 141.5 51 L 140.5 53 L 141.5 51 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 441.5 51 L 444 51.5 L 441.5 52 L 441.5 51 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1910.5 52 L 1912.5 55 L 1910.5 52 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 138.5 53 L 137.5 55 L 138.5 53 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 135.5 55 L 134.5 57 L 135.5 55 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 689.5 55 L 688.5 57 L 689.5 55 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 573.5 57 L 574.5 59 L 573.5 57 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 1914.5 57 L 1915.5 59 L 1914.5 57 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 131.5 58 L 130.5 60 L 131.5 58 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 686.5 59 L 685.5 61 L 686.5 59 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 128.5 60 L 127.5 62 L 128.5 60 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 577.5 60 L 578.5 62 L 577.5 60 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 752.5 60 L 751.5 62 L 752.5 60 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 580.5 62 L 582.5 65 L 580.5 62 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 684.5 62 L 683.5 64 L 684.5 62 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 124.5 63 L 123.5 65 L 124.5 63 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 1854.5 63 L 1855.5 65 L 1854.5 63 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 746.5 64 L 745.5 66 L 746.5 64 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 682.5 65 L 681.5 67 L 682.5 65 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 120.5 66 L 118.5 69 L 120.5 66 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 585.5 66 L 586.5 68 L 585.5 66 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 1858.5 66 L 1860.5 69 L 1858.5 66 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 742.5 67 L 740.5 70 L 742.5 67 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 589.5 69 L 592.5 73 L 589.5 69 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1922.5 69 L 1923.5 71 L 1922.5 69 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 115.5 70 L 112.5 74 L 115.5 70 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 1863.5 70 L 1872.5 80 L 1863.5 70 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 736.5 72 L 731.5 78 L 736.5 72 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 595.5 74 L 599.5 79 L 595.5 74 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 109.5 75 L 105.5 80 L 109.5 75 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 185.5 79 L 184.5 81 L 185.5 79 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 522.5 80 L 523.5 82 L 522.5 80 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 603.5 81 L 623.5 102 L 603.5 81 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 728.5 81 L 726.5 84 L 728.5 81 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 1874.5 82 L 1876.5 85 L 1874.5 82 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 100.5 83 L 83.5 101 L 100.5 83 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 178.5 83 L 177.5 85 L 178.5 83 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 529.5 84 L 530.5 86 L 529.5 84 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 173.5 86 L 172.5 88 L 173.5 86 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 724.5 86 L 723.5 88 L 724.5 86 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1878.5 87 L 1879.5 89 L 1878.5 87 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 537.5 89 L 538.5 91 L 537.5 89 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1880.5 90 L 1881.5 92 L 1880.5 90 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 540.5 91 L 541.5 93 L 540.5 91 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 720.5 92 L 719.5 94 L 720.5 92 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 543.5 93 L 544.5 95 L 543.5 93 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 158.5 96 L 157.5 98 L 158.5 96 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 547.5 96 L 548.5 98 L 547.5 96 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 550.5 98 L 551.5 100 L 550.5 98 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 154.5 99 L 153.5 101 L 154.5 99 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 554.5 101 L 556.5 104 L 554.5 101 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 150.5 102 L 149.5 104 L 150.5 102 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 79.5 105 L 75.5 110 L 79.5 105 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 146.5 105 L 143.5 109 L 146.5 105 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 559.5 105 L 561.5 108 L 559.5 105 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 627.5 106 L 630.5 110 L 627.5 106 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 564.5 109 L 568.5 114 L 564.5 109 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 140.5 110 L 136.5 115 L 140.5 110 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1939.5 110 L 1940 112.5 L 1939 112.5 L 1939.5 110 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 73.5 112 L 70.5 116 L 73.5 112 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 633.5 113 L 635.5 116 L 633.5 113 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 1940.5 115 L 1941 117.5 L 1940 117.5 L 1940.5 115 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 572.5 116 L 590.5 135 L 572.5 116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 132.5 117 L 117.5 133 L 132.5 117 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 68.5 118 L 66.5 121 L 68.5 118 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 637.5 118 L 639.5 121 L 637.5 118 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 661.5 118 L 662 120.5 L 661 120.5 L 661.5 118 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 1941.5 121 L 1942 123.5 L 1941 123.5 L 1941.5 121 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 64.5 123 L 63.5 125 L 64.5 123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 641.5 123 L 642.5 125 L 641.5 123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1894.5 123 L 1895 125.5 L 1894 125.5 L 1894.5 123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 660.5 124 L 661 127.5 L 660 127.5 L 660.5 124 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 707.5 124 L 708 126.5 L 707 126.5 L 707.5 124 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 873.5 124 L 876 124.5 L 873.5 125 L 873.5 124 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1758.5 124 L 1761 124.5 L 1758.5 125 L 1758.5 124 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 61.5 127 L 60.5 129 L 61.5 127 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 644.5 127 L 645.5 129 L 644.5 127 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 1942.5 128 L 1943 133.5 L 1942 133.5 L 1942.5 128 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 1895.5 129 L 1896 132.5 L 1895 132.5 L 1895.5 129 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 59.5 130 L 58.5 132 L 59.5 130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 646.5 130 L 647.5 132 L 646.5 130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 706.5 130 L 707 133.5 L 706 133.5 L 706.5 130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 1777.5 130 L 1778.5 132 L 1777.5 130 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 1780.5 132 L 1781.5 134 L 1780.5 132 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 56.5 134 L 55.5 136 L 56.5 134 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 649.5 134 L 650.5 136 L 649.5 134 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 850.5 134 L 841.5 144 L 850.5 134 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 659.5 135 L 660 148.5 L 659 148.5 L 659.5 135 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 1784.5 135 L 1790.5 142 L 1784.5 135 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 114.5 136 L 110.5 141 L 114.5 136 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 54.5 137 L 53.5 139 L 54.5 137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 651.5 137 L 652.5 139 L 651.5 137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 593.5 138 L 596.5 142 L 593.5 138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 1896.5 139 L 1897 1720.5 L 1896 1720.5 L 1896.5 139 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 52.5 140 L 51.5 142 L 52.5 140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 653.5 140 L 654.5 142 L 653.5 140 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 705.5 142 L 706 1718.5 L 705 1718.5 L 705.5 142 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 50.5 143 L 49.5 145 L 50.5 143 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 108.5 143 L 105.5 147 L 108.5 143 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 598.5 144 L 601.5 148 L 598.5 144 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1792.5 144 L 1793.5 146 L 1792.5 144 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 840.5 145 L 839.5 147 L 840.5 145 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 1794.5 147 L 1795.5 149 L 1794.5 147 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 103.5 149 L 102.5 151 L 103.5 149 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 603.5 150 L 604.5 152 L 603.5 150 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 45.5 151 L 44.5 153 L 45.5 151 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 100.5 153 L 99.5 155 L 100.5 153 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 606.5 154 L 607.5 156 L 606.5 154 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 97.5 157 L 96.5 159 L 97.5 157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 609.5 158 L 610.5 160 L 609.5 158 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 611.5 161 L 612.5 163 L 611.5 161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 613.5 164 L 614.5 166 L 613.5 164 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1801.5 165 L 1802 167.5 L 1801 167.5 L 1801.5 165 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 36.5 167 L 35.5 169 L 36.5 167 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 615.5 167 L 616.5 169 L 615.5 167 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 831.5 169 L 832 676.5 L 831 676.5 L 831.5 169 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 617.5 170 L 618.5 172 L 617.5 170 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 881.5 170 L 1753 170.5 L 881.5 171 L 881.5 170 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 879.5 171 L 879 172.5 L 878.5 174 L 878 172.5 L 879.5 171 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 87.5 172 L 86.5 174 L 87.5 172 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1755.5 173 L 1756 672.5 L 1755 672.5 L 1755.5 173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 620.5 175 L 621.5 177 L 620.5 175 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 623.5 180 L 624.5 182 L 623.5 180 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 8.5 240 L 9 242.5 L 8 242.5 L 8.5 240 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 6.5 249 L 7 251.5 L 6 251.5 L 6.5 249 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 652.5 252 L 653 254.5 L 652 254.5 L 652.5 252 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 5.5 254 L 6 256.5 L 5 256.5 L 5.5 254 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 4.5 260 L 5 262.5 L 4 262.5 L 4.5 260 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 654.5 261 L 655 263.5 L 654 263.5 L 654.5 261 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 51.5 262 L 52 264.5 L 51 264.5 L 51.5 262 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 3.5 266 L 4 268.5 L 3 268.5 L 3.5 266 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 655.5 267 L 656 269.5 L 655 269.5 L 655.5 267 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 50.5 268 L 51 270.5 L 50 270.5 L 50.5 268 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 2.5 273 L 3 276.5 L 2 276.5 L 2.5 273 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 656.5 273 L 657 275.5 L 656 275.5 L 656.5 273 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 49.5 274 L 50 276.5 L 49 276.5 L 49.5 274 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 657.5 280 L 658 283.5 L 657 283.5 L 657.5 280 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 1.5 281 L 2 285.5 L 1 285.5 L 1.5 281 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 48.5 281 L 49 284.5 L 48 284.5 L 48.5 281 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 658.5 288 L 659 293.5 L 658 293.5 L 658.5 288 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 47.5 290 L 48 296.5 L 47 296.5 L 47.5 290 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 0.5 293 L 1 301.5 L 0 301.5 L 0.5 293 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 659.5 303 L 660 1557.5 L 659 1557.5 L 659.5 303 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 46.5 308 L 47 1551.5 L 46 1551.5 L 46.5 308 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 878.5 673 L 880.5 675 L 1753 675.5 L 880.5 676 L 878.5 673 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1801.5 678 L 1802 681.5 L 1801 681.5 L 1801.5 678 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 832.5 681 L 833 683.5 L 832 683.5 L 832.5 681 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 837.5 696 L 838.5 698 L 837.5 696 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 1795.5 697 L 1794.5 699 L 1795.5 697 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1793.5 700 L 1792.5 702 L 1793.5 700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 841.5 702 L 843.5 705 L 841.5 702 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 1791.5 703 L 1783.5 712 L 1791.5 703 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 848.5 709 L 850.5 712 L 848.5 709 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 1781.5 712 L 1780.5 714 L 1781.5 712 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 853.5 713 L 854.5 715 L 853.5 713 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 872.5 721 L 875 721.5 L 872.5 722 L 872.5 721 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 1759.5 721 L 1762 721.5 L 1759.5 722 L 1759.5 721 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 914.5 804 L 919 804.5 L 914.5 805 L 914.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 1020.5 804 L 1025 804.5 L 1020.5 805 L 1020.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 1260.5 804 L 1265 804.5 L 1260.5 805 L 1260.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 1368.5 804 L 1373 804.5 L 1368.5 805 L 1368.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1607.5 804 L 1612 804.5 L 1607.5 805 L 1607.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 1714.5 804 L 1719 804.5 L 1714.5 805 L 1714.5 804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 908.5 805 L 911 805.5 L 908.5 806 L 908.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1029.5 805 L 1032 805.5 L 1029.5 806 L 1029.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1254.5 805 L 1257 805.5 L 1254.5 806 L 1254.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 1376.5 805 L 1379 805.5 L 1376.5 806 L 1376.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 1723.5 805 L 1726 805.5 L 1723.5 806 L 1723.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 1381.5 806 L 1384 806.5 L 1381.5 807 L 1381.5 806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 1224.5 816 L 1223.5 818 L 1224.5 816 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1062.5 817 L 1063.5 819 L 1062.5 817 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 1569.5 817 L 1568.5 819 L 1569.5 817 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 1756.5 817 L 1757.5 819 L 1756.5 817 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 875.5 818 L 874.5 820 L 875.5 818 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 1411.5 818 L 1412.5 820 L 1411.5 818 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 1065.5 819 L 1066.5 821 L 1065.5 819 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1566.5 819 L 1565.5 821 L 1566.5 819 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 1759.5 819 L 1760.5 821 L 1759.5 819 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 872.5 820 L 871.5 822 L 872.5 820 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 1414.5 820 L 1415.5 822 L 1414.5 820 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1068.5 821 L 1069.5 823 L 1068.5 821 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 1563.5 821 L 1562.5 823 L 1563.5 821 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 1762.5 821 L 1763.5 823 L 1762.5 821 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 1215.5 822 L 1213.5 825 L 1215.5 822 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 868.5 823 L 866.5 826 L 868.5 823 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1418.5 823 L 1419.5 825 L 1418.5 823 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 1072.5 824 L 1075.5 828 L 1072.5 824 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 1559.5 824 L 1556.5 828 L 1559.5 824 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 1766.5 824 L 1769.5 828 L 1766.5 824 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1210.5 826 L 1199.5 838 L 1210.5 826 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 1422.5 826 L 1432.5 837 L 1422.5 826 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 863.5 827 L 854.5 837 L 863.5 827 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1084.5 836 L 1087.5 840 L 1084.5 836 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 1547.5 836 L 1544.5 840 L 1547.5 836 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 1778.5 836 L 1781.5 840 L 1778.5 836 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 852.5 839 L 850.5 842 L 852.5 839 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 1434.5 839 L 1436.5 842 L 1434.5 839 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 1197.5 840 L 1195.5 843 L 1197.5 840 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 1089.5 842 L 1090.5 844 L 1089.5 842 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 1542.5 842 L 1541.5 844 L 1542.5 842 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 1783.5 842 L 1784.5 844 L 1783.5 842 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 849.5 843 L 848.5 845 L 849.5 843 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 1194.5 844 L 1193.5 846 L 1194.5 844 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 1091.5 845 L 1092.5 847 L 1091.5 845 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 1540.5 845 L 1539.5 847 L 1540.5 845 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 1785.5 845 L 1786.5 847 L 1785.5 845 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 1192.5 847 L 1191.5 849 L 1192.5 847 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 1093.5 848 L 1094.5 850 L 1093.5 848 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 1538.5 848 L 1537.5 850 L 1538.5 848 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1787.5 848 L 1788.5 850 L 1787.5 848 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 845.5 849 L 844.5 851 L 845.5 849 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 924.5 850 L 1016 850.5 L 924.5 851 L 924.5 850 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 1270.5 850 L 1363 850.5 L 1270.5 851 L 1270.5 850 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 1617.5 850 L 1710 850.5 L 1617.5 851 L 1617.5 850 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 916.5 851 L 919 851.5 L 916.5 852 L 916.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 1020.5 851 L 1023 851.5 L 1020.5 852 L 1020.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 1262.5 851 L 1265 851.5 L 1262.5 852 L 1262.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 1368.5 851 L 1371 851.5 L 1368.5 852 L 1368.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 1609.5 851 L 1612 851.5 L 1609.5 852 L 1609.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 1714.5 851 L 1717 851.5 L 1714.5 852 L 1714.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 1189.5 852 L 1188.5 854 L 1189.5 852 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 901.5 857 L 900.5 859 L 901.5 857 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 1592.5 858 L 1591.5 860 L 1592.5 858 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 898.5 859 L 897.5 861 L 898.5 859 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 1388.5 859 L 1389.5 861 L 1388.5 859 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 1042.5 860 L 1051.5 870 L 1042.5 860 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 1589.5 860 L 1580.5 870 L 1589.5 860 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1736.5 860 L 1739.5 864 L 1736.5 860 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 1241.5 861 L 1235.5 868 L 1241.5 861 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 1392.5 862 L 1396.5 867 L 1392.5 862 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 893.5 863 L 890.5 867 L 893.5 863 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 1742.5 866 L 1745.5 870 L 1742.5 866 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 888.5 869 L 887.5 871 L 888.5 869 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 1233.5 870 L 1232.5 872 L 1233.5 870 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 1399.5 870 L 1400.5 872 L 1399.5 870 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 1231.5 873 L 1230.5 875 L 1231.5 873 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 1577.5 874 L 1576.5 876 L 1577.5 874 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1748.5 874 L 1749.5 876 L 1748.5 874 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 1402.5 875 L 1403.5 877 L 1402.5 875 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 1055.5 876 L 1057 878.5 L 1056 878.5 L 1055.5 876 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 1179.5 877 L 1180 879.5 L 1179 879.5 L 1179.5 877 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 1106.5 880 L 1107 882.5 L 1106 882.5 L 1106.5 880 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 1525.5 880 L 1526 882.5 L 1525 882.5 L 1525.5 880 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1800.5 880 L 1801 882.5 L 1800 882.5 L 1800.5 880 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 1178.5 882 L 1179 884.5 L 1178 884.5 L 1178.5 882 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 832.5 883 L 833 886.5 L 832 886.5 L 832.5 883 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1454.5 883 L 1455 886.5 L 1454 886.5 L 1454.5 883 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 1107.5 886 L 1108 890.5 L 1107 890.5 L 1107.5 886 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 1524.5 886 L 1525 889.5 L 1524 889.5 L 1524.5 886 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 1801.5 886 L 1802 890.5 L 1801 890.5 L 1801.5 886 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 1571.5 888 L 1572 890.5 L 1571 890.5 L 1571.5 888 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 1060.5 889 L 1061 891.5 L 1060 891.5 L 1060.5 889 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 1177.5 890 L 1178 995.5 L 1177 995.5 L 1177.5 890 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 831.5 891 L 832 994.5 L 831 994.5 L 831.5 891 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 1224.5 891 L 1225 893.5 L 1224 893.5 L 1224.5 891 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 878.5 892 L 879 895.5 L 878 895.5 L 878.5 892 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 1408.5 892 L 1409 895.5 L 1408 895.5 L 1408.5 892 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 1455.5 892 L 1456 993.5 L 1455 993.5 L 1455.5 892 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 1570.5 895 L 1571 990.5 L 1570 990.5 L 1570.5 895 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 1061.5 896 L 1062 951.5 L 1061 951.5 L 1061.5 896 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 1755.5 896 L 1756 989.5 L 1755 989.5 L 1755.5 896 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 878.5 990 L 879 994.5 L 878 994.5 L 878.5 990 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 1408.5 990 L 1409 994.5 L 1408 994.5 L 1408.5 990 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 1061.5 992 L 1062 995.5 L 1061 995.5 L 1061.5 992 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 1224.5 992 L 1225 994.5 L 1224 994.5 L 1224.5 992 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 1107.5 995 L 1108 998.5 L 1107 998.5 L 1107.5 995 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 1571.5 995 L 1572 997.5 L 1571 997.5 L 1571.5 995 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 1801.5 995 L 1802 999.5 L 1801 999.5 L 1801.5 995 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 1524.5 996 L 1525 999.5 L 1524 999.5 L 1524.5 996 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 832.5 999 L 833 1002.5 L 832 1002.5 L 832.5 999 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 1454.5 999 L 1455 1002.5 L 1454 1002.5 L 1454.5 999 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 1178.5 1001 L 1179 1003.5 L 1178 1003.5 L 1178.5 1001 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 1106.5 1003 L 1107 1005.5 L 1106 1005.5 L 1106.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 1525.5 1003 L 1526 1005.5 L 1525 1005.5 L 1525.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 1800.5 1003 L 1801 1005.5 L 1800 1005.5 L 1800.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1179.5 1006 L 1180 1008.5 L 1179 1008.5 L 1179.5 1006 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 1403.5 1009 L 1402.5 1011 L 1403.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1749.5 1010 L 1748.5 1012 L 1749.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 1230.5 1011 L 1231.5 1013 L 1230.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 886.5 1014 L 887.5 1016 L 886.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 1232.5 1014 L 1233.5 1016 L 1232.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 1400.5 1014 L 1399.5 1016 L 1400.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 1580.5 1016 L 1581.5 1018 L 1580.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 1745.5 1016 L 1743.5 1019 L 1745.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 1051.5 1017 L 1044.5 1025 L 1051.5 1017 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 1234.5 1017 L 1241.5 1025 L 1234.5 1017 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 889.5 1018 L 895.5 1025 L 889.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 1397.5 1018 L 1392.5 1024 L 1397.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 1738.5 1023 L 1736.5 1026 L 1738.5 1023 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1588.5 1024 L 1589.5 1026 L 1588.5 1024 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1389.5 1025 L 1388.5 1027 L 1389.5 1025 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 1041.5 1026 L 1040.5 1028 L 1041.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 1244.5 1026 L 1245.5 1028 L 1244.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 1188.5 1032 L 1189.5 1034 L 1188.5 1032 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 1608.5 1034 L 1611 1034.5 L 1608.5 1035 L 1608.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 1715.5 1034 L 1718 1034.5 L 1715.5 1035 L 1715.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 844.5 1035 L 845.5 1037 L 844.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 921.5 1035 L 1018 1035.5 L 921.5 1036 L 921.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 1268.5 1035 L 1365 1035.5 L 1268.5 1036 L 1268.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 1614.5 1035 L 1712 1035.5 L 1614.5 1036 L 1614.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 1094.5 1036 L 1093.5 1038 L 1094.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 1537.5 1036 L 1538.5 1038 L 1537.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 1788.5 1036 L 1787.5 1038 L 1788.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 1191.5 1037 L 1192.5 1039 L 1191.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 1092.5 1039 L 1091.5 1041 L 1092.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 1539.5 1039 L 1540.5 1041 L 1539.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 1193.5 1040 L 1194.5 1042 L 1193.5 1040 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 848.5 1041 L 849.5 1043 L 848.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 1090.5 1042 L 1089.5 1044 L 1090.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 1541.5 1042 L 1542.5 1044 L 1541.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 1784.5 1042 L 1783.5 1044 L 1784.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 1195.5 1043 L 1197.5 1046 L 1195.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 850.5 1044 L 852.5 1047 L 850.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 1436.5 1044 L 1435.5 1046 L 1436.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 1087.5 1046 L 1085.5 1049 L 1087.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1544.5 1046 L 1546.5 1049 L 1544.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 1781.5 1046 L 1779.5 1049 L 1781.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 1199.5 1048 L 1211.5 1061 L 1199.5 1048 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 1433.5 1048 L 1422.5 1060 L 1433.5 1048 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 854.5 1049 L 864.5 1060 L 854.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 1776.5 1052 L 1772.5 1057 L 1776.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 1081.5 1053 L 1079.5 1056 L 1081.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 1550.5 1053 L 1552.5 1056 L 1550.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 1074.5 1059 L 1072.5 1062 L 1074.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 1557.5 1059 L 1559.5 1062 L 1557.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 1768.5 1059 L 1766.5 1062 L 1768.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 867.5 1061 L 868.5 1063 L 867.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 1419.5 1061 L 1417.5 1064 L 1419.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 1214.5 1062 L 1215.5 1064 L 1214.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 1069.5 1063 L 1068.5 1065 L 1069.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 1562.5 1063 L 1563.5 1065 L 1562.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1763.5 1063 L 1762.5 1065 L 1763.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 871.5 1064 L 872.5 1066 L 871.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 1415.5 1064 L 1414.5 1066 L 1415.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 874.5 1066 L 875.5 1068 L 874.5 1066 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 1568.5 1067 L 1569.5 1069 L 1568.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 1409.5 1068 L 1408.5 1070 L 1409.5 1068 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 1752.5 1070 L 1751.5 1072 L 1752.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 1575.5 1071 L 1578 1072.5 L 1576.5 1073 L 1575.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 907.5 1080 L 910 1080.5 L 907.5 1081 L 907.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 1253.5 1080 L 1256 1080.5 L 1253.5 1081 L 1253.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 1377.5 1080 L 1380 1080.5 L 1377.5 1081 L 1377.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 913.5 1081 L 917 1081.5 L 913.5 1082 L 913.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 1022.5 1081 L 1027 1081.5 L 1022.5 1082 L 1022.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 1259.5 1081 L 1263 1081.5 L 1259.5 1082 L 1259.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 1370.5 1081 L 1374 1081.5 L 1370.5 1082 L 1370.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 1605.5 1081 L 1610 1081.5 L 1605.5 1082 L 1605.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 1716.5 1081 L 1721 1081.5 L 1716.5 1082 L 1716.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 919.5 1137 L 1021 1137.5 L 919.5 1138 L 919.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 1265.5 1137 L 1368 1137.5 L 1265.5 1138 L 1265.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 1611.5 1137 L 1715 1137.5 L 1611.5 1138 L 1611.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 911.5 1138 L 914 1138.5 L 911.5 1139 L 911.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 1026.5 1138 L 1029 1138.5 L 1026.5 1139 L 1026.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 1256.5 1138 L 1260 1138.5 L 1256.5 1139 L 1256.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 1373.5 1138 L 1377 1138.5 L 1373.5 1139 L 1373.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 1603.5 1138 L 1606 1138.5 L 1603.5 1139 L 1603.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 1720.5 1138 L 1723 1138.5 L 1720.5 1139 L 1720.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 905.5 1139 L 908 1139.5 L 905.5 1140 L 905.5 1139 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 1251.5 1139 L 1254 1139.5 L 1251.5 1140 L 1251.5 1139 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 1379.5 1139 L 1382 1139.5 L 1379.5 1140 L 1379.5 1139 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 1407.5 1149 L 1408.5 1151 L 1407.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 1220.5 1152 L 1219.5 1154 L 1220.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 1066.5 1153 L 1067.5 1155 L 1066.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 1760.5 1153 L 1761.5 1155 L 1760.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 1217.5 1154 L 1216.5 1156 L 1217.5 1154 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 870.5 1155 L 869.5 1157 L 870.5 1155 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 1416.5 1155 L 1417.5 1157 L 1416.5 1155 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 1070.5 1156 L 1071.5 1158 L 1070.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 1561.5 1156 L 1560.5 1158 L 1561.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 1764.5 1156 L 1765.5 1158 L 1764.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 1213.5 1157 L 1211.5 1160 L 1213.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 1419.5 1157 L 1422.5 1161 L 1419.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 866.5 1158 L 863.5 1162 L 866.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 1074.5 1159 L 1085.5 1171 L 1074.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 1768.5 1159 L 1779.5 1171 L 1768.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 1556.5 1160 L 1546.5 1171 L 1556.5 1160 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 1207.5 1162 L 1201.5 1169 L 1207.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 1426.5 1163 L 1428.5 1166 L 1426.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 855.5 1169 L 852.5 1173 L 855.5 1169 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 1432.5 1170 L 1435.5 1174 L 1432.5 1170 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 1199.5 1171 L 1197.5 1174 L 1199.5 1171 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 1087.5 1173 L 1089.5 1176 L 1087.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 1544.5 1173 L 1542.5 1176 L 1544.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1781.5 1173 L 1783.5 1176 L 1781.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 850.5 1175 L 849.5 1177 L 850.5 1175 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 1436.5 1175 L 1437.5 1177 L 1436.5 1175 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 1195.5 1176 L 1194.5 1178 L 1195.5 1176 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 1090.5 1177 L 1091.5 1179 L 1090.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 1541.5 1177 L 1540.5 1179 L 1541.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1784.5 1177 L 1785.5 1179 L 1784.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 1193.5 1179 L 1192.5 1181 L 1193.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 1191.5 1182 L 1190.5 1184 L 1191.5 1182 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 1788.5 1183 L 1789.5 1185 L 1788.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 919.5 1184 L 923 1184.5 L 919.5 1185 L 919.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 1017.5 1184 L 1021 1184.5 L 1017.5 1185 L 1017.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 1265.5 1184 L 1269 1184.5 L 1265.5 1185 L 1265.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 1364.5 1184 L 1368 1184.5 L 1364.5 1185 L 1364.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 1442.5 1184 L 1443.5 1186 L 1442.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 1611.5 1184 L 1616 1184.5 L 1611.5 1185 L 1611.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 1710.5 1184 L 1715 1184.5 L 1710.5 1185 L 1710.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 1596.5 1189 L 1595.5 1191 L 1596.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 1386.5 1191 L 1387.5 1193 L 1386.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 1591.5 1192 L 1590.5 1194 L 1591.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 1734.5 1192 L 1735.5 1194 L 1734.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 1042.5 1193 L 1043.5 1195 L 1042.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1243.5 1193 L 1241.5 1196 L 1243.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 1389.5 1193 L 1392.5 1197 L 1389.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 896.5 1194 L 888.5 1203 L 896.5 1194 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 1587.5 1195 L 1582.5 1201 L 1587.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 1738.5 1195 L 1744.5 1202 L 1738.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 1396.5 1200 L 1399.5 1204 L 1396.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1235.5 1201 L 1233.5 1204 L 1235.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1051.5 1202 L 1052.5 1204 L 1051.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 1580.5 1203 L 1579.5 1205 L 1580.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 1745.5 1203 L 1746.5 1205 L 1745.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 1400.5 1205 L 1401.5 1207 L 1400.5 1205 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 833.5 1211 L 834 1213.5 L 833 1213.5 L 833.5 1211 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 1453.5 1211 L 1454 1213.5 L 1453 1213.5 L 1453.5 1211 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 1525.5 1213 L 1526 1215.5 L 1525 1215.5 L 1525.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 1178.5 1216 L 1179 1218.5 L 1178 1218.5 L 1178.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 832.5 1217 L 833 1219.5 L 832 1219.5 L 832.5 1217 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 1454.5 1217 L 1455 1219.5 L 1454 1219.5 L 1454.5 1217 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1524.5 1219 L 1525 1223.5 L 1524 1223.5 L 1524.5 1219 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 1107.5 1220 L 1108 1224.5 L 1107 1224.5 L 1107.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 1801.5 1220 L 1802 1223.5 L 1801 1223.5 L 1801.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1754.5 1222 L 1755 1224.5 L 1754 1224.5 L 1754.5 1222 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 1177.5 1223 L 1178 1327.5 L 1177 1327.5 L 1177.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 1061.5 1224 L 1062 1226.5 L 1061 1226.5 L 1061.5 1224 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 1224.5 1224 L 1225 1227.5 L 1224 1227.5 L 1224.5 1224 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 831.5 1225 L 832 1326.5 L 831 1326.5 L 831.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 878.5 1225 L 879 1228.5 L 878 1228.5 L 878.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1408.5 1225 L 1409 1228.5 L 1408 1228.5 L 1408.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 1455.5 1225 L 1456 1325.5 L 1455 1325.5 L 1455.5 1225 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 1570.5 1228 L 1571 1324.5 L 1570 1324.5 L 1570.5 1228 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 1755.5 1229 L 1756 1323.5 L 1755 1323.5 L 1755.5 1229 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1408.5 1323 L 1409 1327.5 L 1408 1327.5 L 1408.5 1323 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 878.5 1324 L 879 1327.5 L 878 1327.5 L 878.5 1324 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 1224.5 1325 L 1225 1328.5 L 1224 1328.5 L 1224.5 1325 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1061.5 1326 L 1062 1328.5 L 1061 1328.5 L 1061.5 1326 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 1107.5 1327 L 1108 1331.5 L 1107 1331.5 L 1107.5 1327 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 1801.5 1327 L 1802 1331.5 L 1801 1331.5 L 1801.5 1327 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1524.5 1328 L 1525 1331.5 L 1524 1331.5 L 1524.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 1754.5 1328 L 1755 1330.5 L 1754 1330.5 L 1754.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 1454.5 1331 L 1455 1334.5 L 1454 1334.5 L 1454.5 1331 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 832.5 1332 L 833 1334.5 L 832 1334.5 L 832.5 1332 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 1178.5 1333 L 1179 1335.5 L 1178 1335.5 L 1178.5 1333 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1106.5 1335 L 1107 1337.5 L 1106 1337.5 L 1106.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 1525.5 1335 L 1526 1337.5 L 1525 1337.5 L 1525.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 1800.5 1335 L 1801 1337.5 L 1800 1337.5 L 1800.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 1179.5 1338 L 1180 1340.5 L 1179 1340.5 L 1179.5 1338 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 1526.5 1340 L 1527 1342.5 L 1526 1342.5 L 1526.5 1340 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 885.5 1346 L 886.5 1348 L 885.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1401.5 1346 L 1400.5 1348 L 1401.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 1746.5 1348 L 1745.5 1350 L 1746.5 1348 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 887.5 1349 L 890.5 1353 L 887.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 1052.5 1349 L 1050.5 1352 L 1052.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 1233.5 1349 L 1235.5 1352 L 1233.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 1398.5 1350 L 1395.5 1354 L 1398.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1581.5 1351 L 1587.5 1358 L 1581.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 1743.5 1352 L 1738.5 1358 L 1743.5 1352 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 1393.5 1355 L 1389.5 1360 L 1393.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 894.5 1356 L 897.5 1360 L 894.5 1356 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1044.5 1357 L 1042.5 1360 L 1044.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 1241.5 1357 L 1243.5 1360 L 1241.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1590.5 1359 L 1591.5 1361 L 1590.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 1735.5 1359 L 1734.5 1361 L 1735.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 899.5 1360 L 900.5 1362 L 899.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 1387.5 1360 L 1386.5 1362 L 1387.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1533.5 1360 L 1535 1362.5 L 1533 1361.5 L 1533.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1593.5 1361 L 1594.5 1363 L 1593.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 918.5 1368 L 922 1368.5 L 918.5 1369 L 918.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 1018.5 1368 L 1022 1368.5 L 1018.5 1369 L 1018.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 1264.5 1368 L 1268 1368.5 L 1264.5 1369 L 1264.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 1365.5 1368 L 1369 1368.5 L 1365.5 1369 L 1365.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 1537.5 1368 L 1538.5 1370 L 1537.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 1611.5 1368 L 1614 1368.5 L 1611.5 1369 L 1611.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 1712.5 1368 L 1715 1368.5 L 1712.5 1369 L 1712.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 1193.5 1372 L 1194.5 1374 L 1193.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1439.5 1372 L 1438.5 1374 L 1439.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 1091.5 1373 L 1090.5 1375 L 1091.5 1373 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 1541.5 1374 L 1542.5 1376 L 1541.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 1784.5 1374 L 1783.5 1376 L 1784.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 849.5 1375 L 850.5 1377 L 849.5 1375 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 1195.5 1375 L 1196.5 1377 L 1195.5 1375 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 1089.5 1376 L 1087.5 1379 L 1089.5 1376 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 1436.5 1376 L 1435.5 1378 L 1436.5 1376 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1544.5 1378 L 1546.5 1381 L 1544.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 1781.5 1378 L 1779.5 1381 L 1781.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 852.5 1379 L 855.5 1383 L 852.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 1198.5 1379 L 1203.5 1385 L 1198.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 1433.5 1380 L 1421.5 1393 L 1433.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 1085.5 1381 L 1074.5 1393 L 1085.5 1381 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 1549.5 1384 L 1553.5 1389 L 1549.5 1384 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 1776.5 1384 L 1771.5 1390 L 1776.5 1384 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 1207.5 1388 L 1211.5 1393 L 1207.5 1388 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 864.5 1391 L 866.5 1394 L 864.5 1391 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 1557.5 1391 L 1559.5 1394 L 1557.5 1391 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 1768.5 1391 L 1765.5 1395 L 1768.5 1391 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 1071.5 1394 L 1070.5 1396 L 1071.5 1394 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 1214.5 1394 L 1215.5 1396 L 1214.5 1394 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 1418.5 1394 L 1417.5 1396 L 1418.5 1394 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 869.5 1395 L 870.5 1397 L 869.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 1562.5 1395 L 1563.5 1397 L 1562.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 1763.5 1395 L 1762.5 1397 L 1763.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 1067.5 1397 L 1066.5 1399 L 1067.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 1218.5 1397 L 1219.5 1399 L 1218.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 1064.5 1399 L 1063.5 1401 L 1064.5 1399 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 1409.5 1400 L 1408.5 1402 L 1409.5 1400 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 878.5 1401 L 879.5 1403 L 878.5 1401 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 1573.5 1402 L 1574.5 1404 L 1573.5 1402 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1032.5 1412 L 1035 1412.5 L 1032.5 1413 L 1032.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 1599.5 1412 L 1602 1412.5 L 1599.5 1413 L 1599.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 1724.5 1412 L 1727 1412.5 L 1724.5 1413 L 1724.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 910.5 1413 L 913 1413.5 L 910.5 1414 L 910.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 1027.5 1413 L 1030 1413.5 L 1027.5 1414 L 1027.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 1258.5 1413 L 1262 1413.5 L 1258.5 1414 L 1258.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 1370.5 1413 L 1374 1413.5 L 1370.5 1414 L 1370.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 1605.5 1413 L 1609 1413.5 L 1605.5 1414 L 1605.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 1717.5 1413 L 1721 1413.5 L 1717.5 1414 L 1717.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 917.5 1414 L 1023 1414.5 L 917.5 1415 L 917.5 1414 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 915.5 1469 L 920 1469.5 L 915.5 1470 L 915.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 1022.5 1469 L 1027 1469.5 L 1022.5 1470 L 1022.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 1261.5 1469 L 1266 1469.5 L 1261.5 1470 L 1261.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 1366.5 1469 L 1372 1469.5 L 1366.5 1470 L 1366.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 1607.5 1469 L 1613 1469.5 L 1607.5 1470 L 1607.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 1713.5 1469 L 1719 1469.5 L 1713.5 1470 L 1713.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 908.5 1470 L 911 1470.5 L 908.5 1471 L 908.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 1031.5 1470 L 1034 1470.5 L 1031.5 1471 L 1031.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 1254.5 1470 L 1257 1470.5 L 1254.5 1471 L 1254.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 1376.5 1470 L 1379 1470.5 L 1376.5 1471 L 1376.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 1601.5 1470 L 1604 1470.5 L 1601.5 1471 L 1601.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 1722.5 1470 L 1725 1470.5 L 1722.5 1471 L 1722.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 882.5 1479 L 881.5 1481 L 882.5 1479 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 1059.5 1479 L 1060.5 1481 L 1059.5 1479 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 1406.5 1480 L 1407.5 1482 L 1406.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 1221.5 1483 L 1220.5 1485 L 1221.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 1411.5 1483 L 1412.5 1485 L 1411.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 1566.5 1484 L 1565.5 1486 L 1566.5 1484 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 1759.5 1484 L 1760.5 1486 L 1759.5 1484 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 1218.5 1485 L 1217.5 1487 L 1218.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 1414.5 1485 L 1415.5 1487 L 1414.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 1070.5 1486 L 1071.5 1488 L 1070.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 1762.5 1486 L 1763.5 1488 L 1762.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 1215.5 1487 L 1213.5 1490 L 1215.5 1487 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 1562.5 1487 L 1561.5 1489 L 1562.5 1487 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 868.5 1488 L 866.5 1491 L 868.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 1073.5 1488 L 1075.5 1491 L 1073.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 1418.5 1488 L 1419.5 1490 L 1418.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 1766.5 1489 L 1769.5 1493 L 1766.5 1489 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 1558.5 1490 L 1555.5 1494 L 1558.5 1490 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 1210.5 1491 L 1199.5 1503 L 1210.5 1491 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 1423.5 1492 L 1432.5 1502 L 1423.5 1492 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 862.5 1493 L 855.5 1501 L 862.5 1493 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 1079.5 1493 L 1086.5 1501 L 1079.5 1493 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 1548.5 1500 L 1544.5 1505 L 1548.5 1500 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 1778.5 1501 L 1781.5 1505 L 1778.5 1501 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 1088.5 1503 L 1090.5 1506 L 1088.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 852.5 1504 L 851.5 1506 L 852.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 1434.5 1504 L 1436.5 1507 L 1434.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 1197.5 1505 L 1196.5 1507 L 1197.5 1505 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 1543.5 1506 L 1541.5 1509 L 1543.5 1506 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 1783.5 1507 L 1784.5 1509 L 1783.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 849.5 1508 L 848.5 1510 L 849.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 1092.5 1508 L 1093.5 1510 L 1092.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 1437.5 1508 L 1438.5 1510 L 1437.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 1194.5 1509 L 1193.5 1511 L 1194.5 1509 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 1540.5 1510 L 1539.5 1512 L 1540.5 1510 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 1785.5 1510 L 1786.5 1512 L 1785.5 1510 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 847.5 1511 L 846.5 1513 L 847.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 1094.5 1511 L 1095.5 1513 L 1094.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 1192.5 1512 L 1191.5 1514 L 1192.5 1512 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 1538.5 1513 L 1537.5 1515 L 1538.5 1513 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 1787.5 1513 L 1788.5 1515 L 1787.5 1513 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 845.5 1514 L 844.5 1516 L 845.5 1514 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 1441.5 1514 L 1442.5 1516 L 1441.5 1514 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 917.5 1516 L 920 1516.5 L 917.5 1517 L 917.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 1020.5 1516 L 1023 1516.5 L 1020.5 1517 L 1020.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 1367.5 1516 L 1370 1516.5 L 1367.5 1517 L 1367.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 1609.5 1516 L 1612 1516.5 L 1609.5 1517 L 1609.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 1714.5 1516 L 1717 1516.5 L 1714.5 1517 L 1714.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 1385.5 1522 L 1386.5 1524 L 1385.5 1522 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 1039.5 1523 L 1040.5 1525 L 1039.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 1592.5 1523 L 1591.5 1525 L 1592.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 1733.5 1523 L 1734.5 1525 L 1733.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 898.5 1524 L 896.5 1527 L 898.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 1244.5 1524 L 1243.5 1526 L 1244.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 1388.5 1524 L 1389.5 1526 L 1388.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 1042.5 1525 L 1051.5 1535 L 1042.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 1736.5 1525 L 1745.5 1535 L 1736.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 1588.5 1526 L 1580.5 1535 L 1588.5 1526 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 1240.5 1527 L 1235.5 1533 L 1240.5 1527 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 893.5 1528 L 891.5 1531 L 893.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 1393.5 1528 L 1396.5 1532 L 1393.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 888.5 1534 L 887.5 1536 L 888.5 1534 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 1398.5 1534 L 1399.5 1536 L 1398.5 1534 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 1233.5 1535 L 1232.5 1537 L 1233.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 1052.5 1536 L 1053.5 1538 L 1052.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 1579.5 1536 L 1578.5 1538 L 1579.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 1746.5 1536 L 1747.5 1538 L 1746.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 1231.5 1538 L 1230.5 1540 L 1231.5 1538 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 1749.5 1541 L 1751 1543.5 L 1750 1543.5 L 1749.5 1541 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 1179.5 1542 L 1180 1544.5 L 1179 1544.5 L 1179.5 1542 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 833.5 1543 L 834 1545.5 L 833 1545.5 L 833.5 1543 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 1525.5 1545 L 1526 1547.5 L 1525 1547.5 L 1525.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 1800.5 1545 L 1801 1547.5 L 1800 1547.5 L 1800.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 1178.5 1547 L 1179 1549.5 L 1178 1549.5 L 1178.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 832.5 1548 L 833 1551.5 L 832 1551.5 L 832.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1454.5 1548 L 1455 1551.5 L 1454 1551.5 L 1454.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 1109.5 1549 L 1110 1552.5 L 1109 1552.5 L 1109.5 1549 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 1524.5 1551 L 1525 1554.5 L 1524 1554.5 L 1524.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 1801.5 1551 L 1802 1555.5 L 1801 1555.5 L 1801.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 1060.5 1554 L 1061 1556.5 L 1060 1556.5 L 1060.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 1177.5 1555 L 1178 1660.5 L 1177 1660.5 L 1177.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 1224.5 1556 L 1225 1558.5 L 1224 1558.5 L 1224.5 1556 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 831.5 1557 L 832 1658.5 L 831 1658.5 L 831.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 878.5 1557 L 879 1560.5 L 878 1560.5 L 878.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 1408.5 1557 L 1409 1560.5 L 1408 1560.5 L 1408.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 1455.5 1557 L 1456 1658.5 L 1455 1658.5 L 1455.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 0.5 1558 L 1 1567.5 L 0 1567.5 L 0.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 1110.5 1559 L 1111 1656.5 L 1110 1656.5 L 1110.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 1570.5 1560 L 1571 1655.5 L 1570 1655.5 L 1570.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 1061.5 1561 L 1062 1616.5 L 1061 1616.5 L 1061.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 1755.5 1561 L 1756 1655.5 L 1755 1655.5 L 1755.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 47.5 1563 L 48 1569.5 L 47 1569.5 L 47.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 658.5 1566 L 659 1571.5 L 658 1571.5 L 658.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 1.5 1574 L 2 1578.5 L 1 1578.5 L 1.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 48.5 1575 L 49 1578.5 L 48 1578.5 L 48.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 657.5 1577 L 658 1580.5 L 657 1580.5 L 657.5 1577 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 49.5 1583 L 50 1585.5 L 49 1585.5 L 49.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 2.5 1584 L 3 1587.5 L 2 1587.5 L 2.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 656.5 1584 L 657 1587.5 L 656 1587.5 L 656.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 50.5 1590 L 51 1592.5 L 50 1592.5 L 50.5 1590 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 3.5 1591 L 4 1594.5 L 3 1594.5 L 3.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 655.5 1591 L 656 1593.5 L 655 1593.5 L 655.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 51.5 1595 L 52 1597.5 L 51 1597.5 L 51.5 1595 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 654.5 1596 L 655 1598.5 L 654 1598.5 L 654.5 1596 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 4.5 1598 L 5 1600.5 L 4 1600.5 L 4.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 52.5 1600 L 53 1602.5 L 52 1602.5 L 52.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 653.5 1601 L 654 1603.5 L 653 1603.5 L 653.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 5.5 1603 L 6 1605.5 L 5 1605.5 L 5.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 7.5 1613 L 8 1615.5 L 7 1615.5 L 7.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 878.5 1655 L 879 1659.5 L 878 1659.5 L 878.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 1408.5 1655 L 1409 1659.5 L 1408 1659.5 L 1408.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 1061.5 1657 L 1062 1660.5 L 1061 1660.5 L 1061.5 1657 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 1224.5 1657 L 1225 1659.5 L 1224 1659.5 L 1224.5 1657 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 1571.5 1660 L 1572 1662.5 L 1571 1662.5 L 1571.5 1660 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 1801.5 1660 L 1802 1664.5 L 1801 1664.5 L 1801.5 1660 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 1524.5 1661 L 1525 1664.5 L 1524 1664.5 L 1524.5 1661 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 1109.5 1663 L 1110 1666.5 L 1109 1666.5 L 1109.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 832.5 1664 L 833 1666.5 L 832 1666.5 L 832.5 1664 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 1454.5 1664 L 1455 1667.5 L 1454 1667.5 L 1454.5 1664 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 1178.5 1666 L 1179 1668.5 L 1178 1668.5 L 1178.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 1525.5 1668 L 1526 1670.5 L 1525 1670.5 L 1525.5 1668 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 1800.5 1668 L 1801 1670.5 L 1800 1670.5 L 1800.5 1668 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 1179.5 1671 L 1180 1673.5 L 1179 1673.5 L 1179.5 1671 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 1526.5 1673 L 1527 1675.5 L 1526 1675.5 L 1526.5 1673 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 884.5 1676 L 885.5 1678 L 884.5 1676 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 886.5 1679 L 887.5 1681 L 886.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 1400.5 1679 L 1399.5 1681 L 1400.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 623.5 1680 L 622.5 1682 L 623.5 1680 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 1579.5 1680 L 1581.5 1683 L 1579.5 1680 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 1745.5 1681 L 1743.5 1684 L 1745.5 1681 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 1051.5 1682 L 1043.5 1691 L 1051.5 1682 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 1234.5 1682 L 1241.5 1690 L 1234.5 1682 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 84.5 1683 L 85.5 1685 L 84.5 1683 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 889.5 1683 L 895.5 1690 L 889.5 1683 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 1397.5 1683 L 1391.5 1690 L 1397.5 1683 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 620.5 1685 L 619.5 1687 L 620.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 87.5 1688 L 88.5 1690 L 87.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 1588.5 1689 L 1590.5 1692 L 1588.5 1689 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 1737.5 1689 L 1735.5 1692 L 1737.5 1689 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 89.5 1691 L 90.5 1693 L 89.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 898.5 1691 L 899.5 1693 L 898.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 1041.5 1691 L 1040.5 1693 L 1041.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 1244.5 1691 L 1245.5 1693 L 1244.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 1388.5 1691 L 1387.5 1693 L 1388.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 1592.5 1692 L 1593.5 1694 L 1592.5 1692 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 1733.5 1692 L 1732.5 1694 L 1733.5 1692 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 615.5 1693 L 614.5 1695 L 615.5 1693 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 91.5 1694 L 92.5 1696 L 91.5 1694 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 1249.5 1694 L 1250.5 1696 L 1249.5 1694 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 613.5 1696 L 612.5 1698 L 613.5 1696 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 93.5 1697 L 94.5 1699 L 93.5 1697 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 843.5 1698 L 844.5 1700 L 843.5 1698 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 915.5 1699 L 918 1699.5 L 915.5 1700 L 915.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 1022.5 1699 L 1025 1699.5 L 1022.5 1700 L 1022.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 1261.5 1699 L 1264 1699.5 L 1261.5 1700 L 1261.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 1369.5 1699 L 1372 1699.5 L 1369.5 1700 L 1369.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 95.5 1700 L 96.5 1702 L 95.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 921.5 1700 L 1019 1700.5 L 921.5 1701 L 921.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 1097.5 1700 L 1096.5 1702 L 1097.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 1267.5 1700 L 1366 1700.5 L 1267.5 1701 L 1267.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 1613.5 1700 L 1712 1700.5 L 1613.5 1701 L 1613.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 608.5 1703 L 607.5 1705 L 608.5 1703 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 98.5 1704 L 99.5 1706 L 98.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 1193.5 1705 L 1194.5 1707 L 1193.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 1439.5 1705 L 1438.5 1707 L 1439.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 1093.5 1706 L 1092.5 1708 L 1093.5 1706 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 605.5 1707 L 604.5 1709 L 605.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 1541.5 1707 L 1542.5 1709 L 1541.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 1784.5 1707 L 1783.5 1709 L 1784.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 101.5 1708 L 102.5 1710 L 101.5 1708 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 1195.5 1708 L 1196.5 1710 L 1195.5 1708 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 45.5 1709 L 46.5 1711 L 45.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1091.5 1709 L 1089.5 1712 L 1091.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 1436.5 1709 L 1435.5 1711 L 1436.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 851.5 1710 L 853.5 1713 L 851.5 1710 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 602.5 1711 L 600.5 1714 L 602.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 659.5 1711 L 660 1728.5 L 659 1728.5 L 659.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 1544.5 1711 L 1546.5 1714 L 1544.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 1781.5 1711 L 1779.5 1714 L 1781.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 104.5 1712 L 106.5 1715 L 104.5 1712 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 1198.5 1712 L 1203.5 1718 L 1198.5 1712 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 1433.5 1713 L 1421.5 1726 L 1433.5 1713 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 1087.5 1714 L 1077.5 1725 L 1087.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 656.5 1715 L 655.5 1717 L 656.5 1715 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 598.5 1716 L 595.5 1720 L 598.5 1716 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 856.5 1716 L 862.5 1723 L 856.5 1716 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 1549.5 1717 L 1553.5 1722 L 1549.5 1717 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 1776.5 1717 L 1771.5 1723 L 1776.5 1717 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 109.5 1718 L 112.5 1722 L 109.5 1718 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 654.5 1718 L 653.5 1720 L 654.5 1718 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 652.5 1721 L 651.5 1723 L 652.5 1721 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 1207.5 1721 L 1211.5 1726 L 1207.5 1721 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 592.5 1723 L 585.5 1731 L 592.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 650.5 1724 L 649.5 1726 L 650.5 1724 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 865.5 1724 L 868.5 1728 L 865.5 1724 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 1557.5 1724 L 1559.5 1727 L 1557.5 1724 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 1768.5 1724 L 1765.5 1728 L 1768.5 1724 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 115.5 1725 L 134.5 1745 L 115.5 1725 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 706.5 1726 L 707 1729.5 L 706 1729.5 L 706.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 1074.5 1726 L 1072.5 1729 L 1074.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 57.5 1727 L 58.5 1729 L 57.5 1727 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 1214.5 1727 L 1215.5 1729 L 1214.5 1727 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 1418.5 1727 L 1417.5 1729 L 1418.5 1727 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 1942.5 1727 L 1943 1732.5 L 1942 1732.5 L 1942.5 1727 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 870.5 1728 L 871.5 1730 L 870.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 1562.5 1728 L 1563.5 1730 L 1562.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 1763.5 1728 L 1762.5 1730 L 1763.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 1895.5 1728 L 1896 1731.5 L 1895 1731.5 L 1895.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 1070.5 1729 L 1069.5 1731 L 1070.5 1729 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 59.5 1730 L 60.5 1732 L 59.5 1730 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 1218.5 1730 L 1219.5 1732 L 1218.5 1730 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 645.5 1731 L 644.5 1733 L 645.5 1731 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 1067.5 1731 L 1066.5 1733 L 1067.5 1731 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 707.5 1733 L 708 1735.5 L 707 1735.5 L 707.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 1064.5 1733 L 1063.5 1735 L 1064.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 62.5 1734 L 63.5 1736 L 62.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 660.5 1734 L 661 1737.5 L 660 1737.5 L 660.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 642.5 1735 L 641.5 1737 L 642.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 881.5 1735 L 882.5 1737 L 881.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 1573.5 1735 L 1574.5 1737 L 1573.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 1941.5 1737 L 1942 1739.5 L 1941 1739.5 L 1941.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 65.5 1738 L 67.5 1741 L 65.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 576.5 1739 L 569.5 1747 L 576.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 639.5 1739 L 637.5 1742 L 639.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 661.5 1741 L 662 1743.5 L 661 1743.5 L 661.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 69.5 1743 L 71.5 1746 L 69.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 1940.5 1743 L 1941 1745.5 L 1940 1745.5 L 1940.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 635.5 1744 L 633.5 1747 L 635.5 1744 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 1032.5 1745 L 1035 1745.5 L 1032.5 1746 L 1032.5 1745 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 1599.5 1745 L 1602 1745.5 L 1599.5 1746 L 1599.5 1745 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 1724.5 1745 L 1727 1745.5 L 1724.5 1746 L 1724.5 1745 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 913.5 1746 L 917 1746.5 L 913.5 1747 L 913.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 1025.5 1746 L 1029 1746.5 L 1025.5 1747 L 1025.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 1258.5 1746 L 1262 1746.5 L 1258.5 1747 L 1258.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 1371.5 1746 L 1375 1746.5 L 1371.5 1747 L 1371.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 1605.5 1746 L 1609 1746.5 L 1605.5 1747 L 1605.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 1717.5 1746 L 1721 1746.5 L 1717.5 1747 L 1717.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 138.5 1747 L 141.5 1751 L 138.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 927.5 1747 L 1016 1747.5 L 927.5 1748 L 927.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 1272.5 1747 L 1361 1747.5 L 1272.5 1748 L 1272.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 1619.5 1747 L 1708 1747.5 L 1619.5 1748 L 1619.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 73.5 1748 L 77.5 1753 L 73.5 1748 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 1939.5 1748 L 1940 1750.5 L 1939 1750.5 L 1939.5 1748 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 565.5 1749 L 562.5 1753 L 565.5 1749 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 631.5 1749 L 627.5 1754 L 631.5 1749 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 145.5 1753 L 147.5 1756 L 145.5 1753 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 559.5 1754 L 557.5 1757 L 559.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 80.5 1756 L 104.5 1781 L 80.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_823"
          d="M 150.5 1757 L 151.5 1759 L 150.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_824"
          d="M 624.5 1757 L 602.5 1780 L 624.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_825"
          d="M 554.5 1758 L 553.5 1760 L 554.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_826"
          d="M 154.5 1760 L 155.5 1762 L 154.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_827"
          d="M 550.5 1761 L 549.5 1763 L 550.5 1761 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_828"
          d="M 158.5 1763 L 159.5 1765 L 158.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_829"
          d="M 717.5 1763 L 718.5 1765 L 717.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_830"
          d="M 161.5 1765 L 162.5 1767 L 161.5 1765 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_831"
          d="M 543.5 1766 L 542.5 1768 L 543.5 1766 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_832"
          d="M 164.5 1767 L 165.5 1769 L 164.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_833"
          d="M 540.5 1768 L 539.5 1770 L 540.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_834"
          d="M 167.5 1769 L 168.5 1771 L 167.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_835"
          d="M 537.5 1770 L 536.5 1772 L 537.5 1770 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_836"
          d="M 170.5 1771 L 171.5 1773 L 170.5 1771 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_837"
          d="M 175.5 1774 L 176.5 1776 L 175.5 1774 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_838"
          d="M 724.5 1774 L 725.5 1776 L 724.5 1774 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_839"
          d="M 1876.5 1776 L 1874.5 1779 L 1876.5 1776 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_840"
          d="M 180.5 1777 L 181.5 1779 L 180.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_841"
          d="M 727.5 1778 L 729.5 1781 L 727.5 1778 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_842"
          d="M 520.5 1780 L 519.5 1782 L 520.5 1780 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_843"
          d="M 1872.5 1781 L 1863.5 1791 L 1872.5 1781 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_844"
          d="M 107.5 1782 L 111.5 1787 L 107.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_845"
          d="M 598.5 1782 L 595.5 1786 L 598.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_846"
          d="M 732.5 1784 L 734.5 1787 L 732.5 1784 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_847"
          d="M 677.5 1787 L 678.5 1789 L 677.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_848"
          d="M 114.5 1788 L 116.5 1791 L 114.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_849"
          d="M 591.5 1788 L 589.5 1791 L 591.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_850"
          d="M 738.5 1789 L 741.5 1793 L 738.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_851"
          d="M 1923.5 1790 L 1922.5 1792 L 1923.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_852"
          d="M 119.5 1792 L 121.5 1795 L 119.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_853"
          d="M 586.5 1792 L 584.5 1795 L 586.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_854"
          d="M 680.5 1792 L 681.5 1794 L 680.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_855"
          d="M 1860.5 1792 L 1858.5 1795 L 1860.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_856"
          d="M 744.5 1794 L 745.5 1796 L 744.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_857"
          d="M 682.5 1795 L 683.5 1797 L 682.5 1795 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_858"
          d="M 124.5 1796 L 125.5 1798 L 124.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_859"
          d="M 581.5 1796 L 580.5 1798 L 581.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_860"
          d="M 747.5 1796 L 748.5 1798 L 747.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_861"
          d="M 684.5 1798 L 685.5 1800 L 684.5 1798 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_862"
          d="M 128.5 1799 L 129.5 1801 L 128.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_863"
          d="M 577.5 1799 L 576.5 1801 L 577.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_864"
          d="M 574.5 1801 L 573.5 1803 L 574.5 1801 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_865"
          d="M 687.5 1802 L 688.5 1804 L 687.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_866"
          d="M 1915.5 1802 L 1914.5 1804 L 1915.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_867"
          d="M 135.5 1804 L 136.5 1806 L 135.5 1804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_868"
          d="M 570.5 1804 L 569.5 1806 L 570.5 1804 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_869"
          d="M 138.5 1806 L 139.5 1808 L 138.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_870"
          d="M 567.5 1806 L 566.5 1808 L 567.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_871"
          d="M 690.5 1806 L 692.5 1809 L 690.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_872"
          d="M 1912.5 1806 L 1910.5 1809 L 1912.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_873"
          d="M 141.5 1808 L 142.5 1810 L 141.5 1808 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_874"
          d="M 564.5 1808 L 563.5 1810 L 564.5 1808 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_875"
          d="M 267.5 1809 L 270 1809.5 L 267.5 1810 L 267.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_876"
          d="M 437.5 1809 L 440 1809.5 L 437.5 1810 L 437.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_877"
          d="M 273.5 1810 L 276 1810.5 L 273.5 1811 L 273.5 1810 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_878"
          d="M 431.5 1810 L 434 1810.5 L 431.5 1811 L 431.5 1810 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_879"
          d="M 279.5 1811 L 283 1811.5 L 279.5 1812 L 279.5 1811 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_880"
          d="M 419.5 1811 L 423 1811.5 L 419.5 1812 L 419.5 1811 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_881"
          d="M 1908.5 1811 L 1893.5 1827 L 1908.5 1811 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_882"
          d="M 288.5 1812 L 293 1812.5 L 288.5 1813 L 288.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_883"
          d="M 410.5 1812 L 415 1812.5 L 410.5 1813 L 410.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_884"
          d="M 695.5 1812 L 706.5 1824 L 695.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_885"
          d="M 1816.5 1812 L 1819 1812.5 L 1816.5 1813 L 1816.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_886"
          d="M 149.5 1813 L 150.5 1815 L 149.5 1813 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_887"
          d="M 296.5 1813 L 300 1813.5 L 296.5 1814 L 296.5 1813 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_888"
          d="M 307.5 1813 L 312 1813.5 L 307.5 1814 L 307.5 1813 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_889"
          d="M 556.5 1813 L 555.5 1815 L 556.5 1813 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_890"
          d="M 789.5 1813 L 793 1813.5 L 789.5 1814 L 789.5 1813 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_891"
          d="M 1809.5 1813 L 1813 1813.5 L 1809.5 1814 L 1809.5 1813 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_892"
          d="M 709.5 1826 L 710 1886.5 L 709 1886.5 L 709.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_893"
          d="M 1890.5 1828 L 1888.5 1831 L 1890.5 1828 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_894"
          d="M 1885.5 1832 L 1884.5 1834 L 1885.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_895"
          d="M 243.5 1852 L 246 1852.5 L 243.5 1853 L 243.5 1852 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_896"
          d="M 456.5 1853 L 459 1853.5 L 456.5 1854 L 456.5 1853 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_897"
          d="M 756.5 1853 L 757 1888.5 L 756 1888.5 L 756.5 1853 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_898"
          d="M 451.5 1854 L 454 1854.5 L 451.5 1855 L 451.5 1854 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_899"
          d="M 258.5 1855 L 261 1855.5 L 258.5 1856 L 258.5 1855 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_900"
          d="M 446.5 1855 L 449 1855.5 L 446.5 1856 L 446.5 1855 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_901"
          d="M 264.5 1856 L 267 1856.5 L 264.5 1857 L 264.5 1856 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_902"
          d="M 440.5 1856 L 443 1856.5 L 440.5 1857 L 440.5 1856 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_903"
          d="M 768.5 1856 L 771 1856.5 L 768.5 1857 L 768.5 1856 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_904"
          d="M 268.5 1857 L 269 1900.5 L 268 1900.5 L 268.5 1857 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_905"
          d="M 433.5 1857 L 436 1857.5 L 433.5 1858 L 433.5 1857 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_906"
          d="M 429.5 1858 L 430 1882.5 L 429 1882.5 L 429.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_907"
          d="M 778.5 1858 L 781 1858.5 L 778.5 1859 L 778.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_908"
          d="M 1825.5 1858 L 1828 1858.5 L 1825.5 1859 L 1825.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_909"
          d="M 785.5 1859 L 789 1859.5 L 785.5 1860 L 785.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_910"
          d="M 1818.5 1859 L 1822 1859.5 L 1818.5 1860 L 1818.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_911"
          d="M 796.5 1860 L 825 1860.5 L 796.5 1861 L 796.5 1860 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_912"
          d="M 1807.5 1860 L 1814 1860.5 L 1807.5 1861 L 1807.5 1860 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_913"
          d="M 315.5 1861 L 316 1905.5 L 315 1905.5 L 315.5 1861 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_914"
          d="M 824.5 1880 L 825 1901.5 L 824 1901.5 L 824.5 1880 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_915"
          d="M 383.5 1883 L 384 1891.5 L 383 1891.5 L 383.5 1883 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_916"
          d="M 430.5 1889 L 431 1892.5 L 430 1892.5 L 430.5 1889 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_917"
          d="M 708.5 1892 L 709 1894.5 L 708 1894.5 L 708.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_918"
          d="M 755.5 1895 L 756 1898.5 L 755 1898.5 L 755.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_919"
          d="M 431.5 1896 L 432 1898.5 L 431 1898.5 L 431.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_920"
          d="M 384.5 1897 L 385 1899.5 L 384 1899.5 L 384.5 1897 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_921"
          d="M 754.5 1902 L 755 1904.5 L 754 1904.5 L 754.5 1902 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_922"
          d="M 385.5 1904 L 386 1906.5 L 385 1906.5 L 385.5 1904 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_923"
          d="M 870.5 1907 L 871 1913.5 L 870 1913.5 L 870.5 1907 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_924"
          d="M 753.5 1908 L 754 1910.5 L 753 1910.5 L 753.5 1908 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_925"
          d="M 386.5 1909 L 387 1911.5 L 386 1911.5 L 386.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_926"
          d="M 269.5 1910 L 270 1915.5 L 269 1915.5 L 269.5 1910 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_927"
          d="M 823.5 1910 L 824 1914.5 L 823 1914.5 L 823.5 1910 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_928"
          d="M 316.5 1912 L 317 1916.5 L 316 1916.5 L 316.5 1912 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_929"
          d="M 822.5 1919 L 823 1921.5 L 822 1921.5 L 822.5 1919 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_930"
          d="M 869.5 1919 L 870 1923.5 L 869 1923.5 L 869.5 1919 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_931"
          d="M 317.5 1920 L 318 1923.5 L 317 1923.5 L 317.5 1920 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_932"
          d="M 270.5 1921 L 271 1924.5 L 270 1924.5 L 270.5 1921 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_933"
          d="M 821.5 1925 L 822 1927.5 L 821 1927.5 L 821.5 1925 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_934"
          d="M 318.5 1927 L 319 1929.5 L 318 1929.5 L 318.5 1927 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_935"
          d="M 868.5 1927 L 869 1930.5 L 868 1930.5 L 868.5 1927 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_936"
          d="M 271.5 1929 L 272 1931.5 L 271 1931.5 L 271.5 1929 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_937"
          d="M 442.5 1929 L 443.5 1931 L 442.5 1929 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_938"
          d="M 319.5 1932 L 320 1934.5 L 319 1934.5 L 319.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_939"
          d="M 867.5 1934 L 868 1936.5 L 867 1936.5 L 867.5 1934 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_940"
          d="M 272.5 1935 L 273 1937.5 L 272 1937.5 L 272.5 1935 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_941"
          d="M 691.5 1938 L 690.5 1940 L 691.5 1938 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_942"
          d="M 448.5 1939 L 449.5 1941 L 448.5 1939 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_943"
          d="M 866.5 1939 L 867 1941.5 L 866 1941.5 L 866.5 1939 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_944"
          d="M 273.5 1940 L 274 1942.5 L 273 1942.5 L 273.5 1940 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_945"
          d="M 689.5 1941 L 688.5 1943 L 689.5 1941 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_946"
          d="M 450.5 1942 L 451.5 1944 L 450.5 1942 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_947"
          d="M 865.5 1944 L 866 1946.5 L 865 1946.5 L 865.5 1944 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_948"
          d="M 274.5 1945 L 275 1947.5 L 274 1947.5 L 274.5 1945 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_949"
          d="M 686.5 1945 L 684.5 1948 L 686.5 1945 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_950"
          d="M 453.5 1946 L 455.5 1949 L 453.5 1946 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_951"
          d="M 682.5 1950 L 678.5 1955 L 682.5 1950 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_952"
          d="M 458.5 1952 L 470.5 1965 L 458.5 1952 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_953"
          d="M 737.5 1953 L 736.5 1955 L 737.5 1953 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_954"
          d="M 671.5 1961 L 666.5 1967 L 671.5 1961 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_955"
          d="M 731.5 1963 L 730.5 1965 L 731.5 1963 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_956"
          d="M 729.5 1966 L 728.5 1968 L 729.5 1966 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_957"
          d="M 474.5 1967 L 476.5 1970 L 474.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_958"
          d="M 663.5 1968 L 661.5 1971 L 663.5 1968 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_959"
          d="M 412.5 1969 L 413.5 1971 L 412.5 1969 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_960"
          d="M 727.5 1969 L 726.5 1971 L 727.5 1969 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_961"
          d="M 479.5 1971 L 480.5 1973 L 479.5 1971 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_962"
          d="M 659.5 1971 L 658.5 1973 L 659.5 1971 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_963"
          d="M 414.5 1972 L 416.5 1975 L 414.5 1972 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_964"
          d="M 482.5 1973 L 483.5 1975 L 482.5 1973 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_965"
          d="M 724.5 1973 L 723.5 1975 L 724.5 1973 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_966"
          d="M 655.5 1974 L 654.5 1976 L 655.5 1974 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_967"
          d="M 485.5 1975 L 486.5 1977 L 485.5 1975 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_968"
          d="M 417.5 1976 L 419.5 1979 L 417.5 1976 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_969"
          d="M 488.5 1977 L 489.5 1979 L 488.5 1977 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_970"
          d="M 721.5 1977 L 718.5 1981 L 721.5 1977 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_971"
          d="M 495.5 1981 L 496.5 1983 L 495.5 1981 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_972"
          d="M 422.5 1982 L 427.5 1988 L 422.5 1982 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_973"
          d="M 716.5 1983 L 699.5 2001 L 716.5 1983 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_974"
          d="M 340.5 1990 L 341.5 1992 L 340.5 1990 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_975"
          d="M 435.5 1995 L 441.5 2002 L 435.5 1995 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_976"
          d="M 344.5 1997 L 345.5 1999 L 344.5 1997 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_977"
          d="M 538.5 1997 L 541 1997.5 L 538.5 1998 L 538.5 1997 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_978"
          d="M 544.5 1998 L 547 1998.5 L 544.5 1999 L 544.5 1998 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_979"
          d="M 593.5 1998 L 596 1998.5 L 593.5 1999 L 593.5 1998 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_980"
          d="M 550.5 1999 L 555 1999.5 L 550.5 2000 L 550.5 1999 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_981"
          d="M 584.5 1999 L 589 1999.5 L 584.5 2000 L 584.5 1999 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_982"
          d="M 562.5 2000 L 577 2000.5 L 562.5 2001 L 562.5 2000 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_983"
          d="M 696.5 2002 L 694.5 2005 L 696.5 2002 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_984"
          d="M 444.5 2003 L 446.5 2006 L 444.5 2003 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_985"
          d="M 791.5 2003 L 790.5 2005 L 791.5 2003 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_986"
          d="M 295.5 2005 L 296.5 2007 L 295.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_987"
          d="M 349.5 2005 L 350.5 2007 L 349.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_988"
          d="M 691.5 2006 L 689.5 2009 L 691.5 2006 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_989"
          d="M 789.5 2006 L 788.5 2008 L 789.5 2006 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_990"
          d="M 449.5 2007 L 450.5 2009 L 449.5 2007 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_991"
          d="M 351.5 2008 L 352.5 2010 L 351.5 2008 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_992"
          d="M 787.5 2009 L 786.5 2011 L 787.5 2009 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_993"
          d="M 453.5 2010 L 454.5 2012 L 453.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_994"
          d="M 686.5 2010 L 685.5 2012 L 686.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_995"
          d="M 354.5 2012 L 355.5 2014 L 354.5 2012 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_996"
          d="M 683.5 2012 L 682.5 2014 L 683.5 2012 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_997"
          d="M 784.5 2013 L 783.5 2015 L 784.5 2013 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_998"
          d="M 680.5 2014 L 679.5 2016 L 680.5 2014 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_999"
          d="M 356.5 2015 L 358.5 2018 L 356.5 2015 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1000"
          d="M 301.5 2016 L 302.5 2018 L 301.5 2016 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1001"
          d="M 677.5 2016 L 676.5 2018 L 677.5 2016 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1002"
          d="M 782.5 2016 L 780.5 2019 L 782.5 2016 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1003"
          d="M 465.5 2018 L 466.5 2020 L 465.5 2018 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1004"
          d="M 359.5 2019 L 361.5 2022 L 359.5 2019 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1005"
          d="M 779.5 2020 L 777.5 2023 L 779.5 2020 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1006"
          d="M 363.5 2024 L 366.5 2028 L 363.5 2024 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1007"
          d="M 833.5 2024 L 832.5 2026 L 833.5 2024 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1008"
          d="M 307.5 2026 L 308.5 2028 L 307.5 2026 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1009"
          d="M 774.5 2026 L 771.5 2030 L 774.5 2026 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1010"
          d="M 309.5 2029 L 310.5 2031 L 309.5 2029 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1011"
          d="M 369.5 2031 L 389.5 2052 L 369.5 2031 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1012"
          d="M 311.5 2032 L 312.5 2034 L 311.5 2032 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1013"
          d="M 768.5 2033 L 752.5 2050 L 768.5 2033 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1014"
          d="M 313.5 2035 L 314.5 2037 L 313.5 2035 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1015"
          d="M 315.5 2038 L 316.5 2040 L 315.5 2038 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1016"
          d="M 823.5 2039 L 822.5 2041 L 823.5 2039 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1017"
          d="M 318.5 2042 L 319.5 2044 L 318.5 2042 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1018"
          d="M 820.5 2043 L 819.5 2045 L 820.5 2043 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1019"
          d="M 533.5 2044 L 536 2044.5 L 533.5 2045 L 533.5 2044 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1020"
          d="M 604.5 2044 L 607 2044.5 L 604.5 2045 L 604.5 2044 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1021"
          d="M 539.5 2045 L 542 2045.5 L 539.5 2046 L 539.5 2045 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1022"
          d="M 598.5 2045 L 601 2045.5 L 598.5 2046 L 598.5 2045 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1023"
          d="M 321.5 2046 L 322.5 2048 L 321.5 2046 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1024"
          d="M 546.5 2046 L 551 2046.5 L 546.5 2047 L 546.5 2046 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1025"
          d="M 589.5 2046 L 594 2046.5 L 589.5 2047 L 589.5 2046 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1026"
          d="M 558.5 2047 L 582 2047.5 L 558.5 2048 L 558.5 2047 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1027"
          d="M 817.5 2047 L 816.5 2049 L 817.5 2047 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1028"
          d="M 324.5 2050 L 326.5 2053 L 324.5 2050 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1029"
          d="M 814.5 2051 L 812.5 2054 L 814.5 2051 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1030"
          d="M 748.5 2052 L 745.5 2056 L 748.5 2052 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1031"
          d="M 392.5 2053 L 395.5 2057 L 392.5 2053 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1032"
          d="M 328.5 2055 L 332.5 2060 L 328.5 2055 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1033"
          d="M 742.5 2057 L 739.5 2061 L 742.5 2057 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1034"
          d="M 809.5 2057 L 806.5 2061 L 809.5 2057 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1035"
          d="M 399.5 2059 L 400.5 2061 L 399.5 2059 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1036"
          d="M 737.5 2061 L 735.5 2064 L 737.5 2061 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1037"
          d="M 334.5 2062 L 357.5 2086 L 334.5 2062 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1038"
          d="M 403.5 2062 L 405.5 2065 L 403.5 2062 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1039"
          d="M 803.5 2064 L 783.5 2085 L 803.5 2064 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1040"
          d="M 407.5 2065 L 408.5 2067 L 407.5 2065 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1041"
          d="M 732.5 2065 L 731.5 2067 L 732.5 2065 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1042"
          d="M 729.5 2067 L 728.5 2069 L 729.5 2067 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1043"
          d="M 411.5 2068 L 412.5 2070 L 411.5 2068 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1044"
          d="M 414.5 2070 L 415.5 2072 L 414.5 2070 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1045"
          d="M 417.5 2072 L 418.5 2074 L 417.5 2072 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1046"
          d="M 420.5 2074 L 421.5 2076 L 420.5 2074 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1047"
          d="M 430.5 2080 L 431.5 2082 L 430.5 2080 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1048"
          d="M 707.5 2081 L 706.5 2083 L 707.5 2081 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1049"
          d="M 779.5 2087 L 776.5 2091 L 779.5 2087 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1050"
          d="M 361.5 2088 L 364.5 2092 L 361.5 2088 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1051"
          d="M 367.5 2093 L 370.5 2097 L 367.5 2093 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1052"
          d="M 772.5 2093 L 770.5 2096 L 772.5 2093 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1053"
          d="M 767.5 2097 L 766.5 2099 L 767.5 2097 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1054"
          d="M 373.5 2098 L 374.5 2100 L 373.5 2098 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1055"
          d="M 763.5 2100 L 761.5 2103 L 763.5 2100 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1056"
          d="M 377.5 2101 L 378.5 2103 L 377.5 2101 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1057"
          d="M 759.5 2103 L 758.5 2105 L 759.5 2103 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1058"
          d="M 381.5 2104 L 382.5 2106 L 381.5 2104 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1059"
          d="M 384.5 2106 L 385.5 2108 L 384.5 2106 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1060"
          d="M 755.5 2106 L 754.5 2108 L 755.5 2106 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1061"
          d="M 752.5 2108 L 751.5 2110 L 752.5 2108 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1062"
          d="M 749.5 2110 L 748.5 2112 L 749.5 2110 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1063"
          d="M 627.5 2111 L 630 2111.5 L 627.5 2112 L 627.5 2111 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1064"
          d="M 622.5 2112 L 625 2112.5 L 622.5 2113 L 622.5 2112 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1065"
          d="M 746.5 2112 L 745.5 2114 L 746.5 2112 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1066"
          d="M 520.5 2113 L 523 2113.5 L 520.5 2114 L 520.5 2113 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1067"
          d="M 617.5 2113 L 620 2113.5 L 617.5 2114 L 617.5 2113 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1068"
          d="M 526.5 2114 L 530 2114.5 L 526.5 2115 L 526.5 2114 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1069"
          d="M 610.5 2114 L 613 2114.5 L 610.5 2115 L 610.5 2114 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1070"
          d="M 743.5 2114 L 742.5 2116 L 743.5 2114 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1071"
          d="M 533.5 2115 L 538 2115.5 L 533.5 2116 L 533.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1072"
          d="M 602.5 2115 L 606 2115.5 L 602.5 2116 L 602.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1073"
          d="M 399.5 2116 L 400.5 2118 L 399.5 2116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1074"
          d="M 542.5 2116 L 548 2116.5 L 542.5 2117 L 542.5 2116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1075"
          d="M 592.5 2116 L 597 2116.5 L 592.5 2117 L 592.5 2116 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1076"
          d="M 556.5 2117 L 583 2117.5 L 556.5 2118 L 556.5 2117 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1077"
          d="M 404.5 2119 L 405.5 2121 L 404.5 2119 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1078"
          d="M 411.5 2123 L 412.5 2125 L 411.5 2123 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1079"
          d="M 492.5 2155 L 495 2155.5 L 492.5 2156 L 492.5 2155 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1080"
          d="M 501.5 2157 L 504 2157.5 L 501.5 2158 L 501.5 2157 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1081"
          d="M 506.5 2158 L 509 2158.5 L 506.5 2159 L 506.5 2158 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1082"
          d="M 512.5 2159 L 515 2159.5 L 512.5 2160 L 512.5 2159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1083"
          d="M 625.5 2159 L 628 2159.5 L 625.5 2160 L 625.5 2159 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1084"
          d="M 518.5 2160 L 521 2160.5 L 518.5 2161 L 518.5 2160 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1085"
          d="M 619.5 2160 L 622 2160.5 L 619.5 2161 L 619.5 2160 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1086"
          d="M 525.5 2161 L 528 2161.5 L 525.5 2162 L 525.5 2161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1087"
          d="M 611.5 2161 L 615 2161.5 L 611.5 2162 L 611.5 2161 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1088"
          d="M 533.5 2162 L 538 2162.5 L 533.5 2163 L 533.5 2162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1089"
          d="M 602.5 2162 L 607 2162.5 L 602.5 2163 L 602.5 2162 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1090"
          d="M 543.5 2163 L 551 2163.5 L 543.5 2164 L 543.5 2163 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1091"
          d="M 589.5 2163 L 597 2163.5 L 589.5 2164 L 589.5 2163 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1092"
          d="M 565.5 2164 L 575 2164.5 L 565.5 2165 L 565.5 2164 Z"
          fill="currentColor"
          fillOpacity="0.7215686"
          stroke="currentColor"
          strokeOpacity="0.7215686"
          strokeWidth="1"/>
        <path
          id="path_1093"
          d="M 304.5 0 L 402.5 0 L 403.5 1 L 419.5 1 L 420.5 2 L 429.5 2 L 430.5 3 L 454.5 6 L 482.5 13 Q 572.1 41.9 627 105.5 Q 644.8 125.8 659.5 149 L 660 128.5 L 661 127.5 L 662 115.5 L 670 88.5 Q 683.6 57.1 707.5 36 Q 725.3 19.8 749.5 10 L 772.5 3 L 783.5 2 L 784.5 1 L 794.5 1 L 795.5 0 L 1806.5 0 L 1807.5 1 L 1817.5 1 L 1818.5 2 L 1829.5 3 L 1855.5 11 Q 1888.6 25.4 1910 51.5 Q 1924.9 69.1 1934 92.5 L 1939 108.5 L 1942 124.5 L 1942 133.5 L 1943 134.5 L 1943 1726.5 L 1942 1727.5 L 1941 1742.5 L 1937 1759.5 Q 1932 1776 1924 1789.5 Q 1910.9 1811.9 1891.5 1828 Q 1873.9 1842.9 1850.5 1852 L 1829.5 1858 L 1818.5 1859 L 1817.5 1860 L 1807.5 1860 L 1806.5 1861 L 871 1861 L 871 1906.5 L 870 1907.5 L 870 1918.5 L 869 1919.5 L 868 1933.5 L 861 1963.5 L 850 1993.5 Q 824.3 2049.3 780.5 2087 Q 738.3 2124.8 679.5 2146 L 640.5 2157 L 618.5 2161 L 602.5 2162 L 601.5 2163 L 589.5 2163 L 588.5 2164 L 551.5 2164 L 550.5 2163 L 538.5 2163 L 537.5 2162 L 521.5 2161 L 490.5 2155 L 457.5 2145 L 435.5 2136 Q 374.4 2108.1 333 2060.5 Q 298.4 2022.1 280 1967.5 L 275 1949.5 L 270 1920.5 L 270 1910.5 L 269 1909.5 L 269 1857 L 241.5 1852 L 210.5 1843 Q 184.3 1833.7 161.5 1821 Q 113.3 1793.7 78 1753.5 Q 40.7 1711.8 19 1654.5 L 11 1629.5 L 6 1608.5 L 3 1584.5 L 2 1583.5 L 1 1558.5 L 0 1557.5 L 0 302.5 L 1 301.5 L 1 286.5 L 2 285.5 L 3 269.5 L 9 238.5 Q 17.1 206.6 30 179.5 Q 58.5 121 104.5 80 Q 143.3 44.8 195.5 23 L 217.5 15 L 247.5 7 L 269.5 3 L 276.5 3 L 277.5 2 L 303.5 1 L 304.5 0 Z M 312 46 L 311 47 L 292 47 L 291 48 L 282 48 L 281 49 L 269 50 L 246 55 L 221 63 Q 169 83 133 117 Q 94 153 70 204 Q 60 227 53 254 L 48 282 L 47 308 L 46 309 L 46 1552 L 47 1553 L 47 1570 L 48 1571 L 50 1593 L 56 1619 L 64 1643 Q 83 1691 115 1726 Q 152 1768 208 1792 L 235 1802 L 258 1808 L 280 1812 L 296 1813 L 297 1814 L 312 1814 L 313 1813 L 399 1813 L 400 1814 L 402 1813 L 415 1813 L 424 1811 L 440 1810 Q 465 1805 487 1797 Q 534 1778 570 1747 Q 610 1711 635 1660 Q 647 1634 654 1604 L 658 1581 L 659 1559 L 660 1558 L 660 304 L 659 303 L 658 281 L 653 253 Q 647 228 638 208 Q 620 166 591 135 Q 564 105 530 84 Q 501 66 465 56 L 444 51 L 426 49 L 425 48 L 416 48 L 415 47 L 396 47 L 395 46 L 312 46 Z M 802 46 L 801 47 L 784 48 L 767 53 Q 749 60 737 72 Q 721 86 712 108 L 707 125 L 706 142 L 705 143 L 705 1719 L 706 1720 L 707 1736 L 712 1753 Q 720 1771 732 1785 Q 753 1807 790 1814 L 1813 1814 L 1836 1808 Q 1851 1801 1864 1791 Q 1881 1776 1890 1754 L 1894 1742 L 1896 1732 L 1896 1722 L 1897 1721 L 1897 140 L 1896 139 L 1895 124 L 1888 103 Q 1882 90 1873 80 Q 1858 62 1836 53 L 1814 47 L 1802 47 L 1801 46 L 802 46 Z M 660 1711 Q 645 1734 627 1755 Q 592 1794 545 1821 Q 518 1836 487 1846 L 461 1853 L 429 1858 L 429 1883 L 430 1884 L 431 1899 L 434 1911 Q 442 1935 458 1953 Q 476 1973 503 1986 Q 519 1994 539 1998 L 550 1999 L 551 2000 L 562 2000 L 563 2001 L 589 2000 L 617 1994 Q 646 1985 667 1967 Q 683 1953 695 1934 L 705 1912 L 710 1887 L 710 1827 Q 685 1806 671 1775 L 662 1747 L 661 1735 L 660 1734 L 660 1711 Z M 756 1853 L 756 1895 L 751 1921 Q 740 1957 718 1982 Q 696 2007 666 2024 Q 649 2033 630 2039 L 610 2044 L 599 2045 L 598 2046 L 590 2046 L 589 2047 L 552 2047 L 551 2046 L 543 2046 L 514 2040 L 499 2035 Q 461 2021 435 1995 Q 410 1973 396 1941 L 387 1914 L 384 1897 L 384 1884 L 383 1883 L 383 1862 L 383 1861 L 315 1861 L 315 1906 L 316 1907 L 316 1917 L 317 1918 L 318 1930 L 322 1947 Q 337 1997 369 2032 Q 401 2068 447 2090 Q 470 2102 498 2109 L 527 2115 L 542 2116 L 543 2117 L 556 2117 L 557 2118 L 583 2118 L 584 2117 L 597 2117 L 598 2116 L 620 2114 L 650 2107 L 668 2101 Q 717 2082 753 2050 Q 790 2017 811 1967 L 820 1938 L 824 1915 L 825 1860 L 790 1860 L 789 1859 L 776 1858 L 756 1853 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1094"
          d="M 876.5 124 L 1757.5 124 L 1776.5 130 L 1792 143.5 L 1800 158.5 L 1802 168.5 L 1802 677.5 L 1800 687.5 L 1796 696.5 L 1782.5 712 L 1770.5 719 L 1758.5 722 L 875.5 722 Q 855.1 718.4 844 705.5 Q 835 696 832 680.5 L 832 165.5 Q 836.4 143.4 852.5 133 L 863.5 127 L 876.5 124 Z M 882 170 L 878 173 L 878 674 L 881 676 L 1753 676 L 1755 675 L 1756 673 L 1756 174 L 1755 171 L 1753 170 L 882 170 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1095"
          d="M 919.5 804 L 1019.5 804 L 1020.5 805 L 1028.5 805 Q 1064.2 812.3 1084 835.5 Q 1101.3 853.7 1107 883.5 Q 1105.3 889.7 1108 891.5 L 1108 994.5 L 1104 1015.5 L 1095 1035.5 Q 1087 1049 1075.5 1059 Q 1057.9 1075.4 1029.5 1081 Q 1023.3 1079.3 1021.5 1082 L 917.5 1082 L 901.5 1079 L 879.5 1070 Q 864 1061 853 1047.5 Q 843.9 1036.6 838 1022.5 L 832 998.5 L 832 887.5 Q 838.9 846.9 865.5 826 L 887.5 812 L 898.5 808 L 919.5 804 Z M 925 850 Q 923 853 917 851 L 908 854 L 894 863 Q 882 874 878 893 L 878 995 Q 881 1009 889 1019 Q 900 1032 922 1036 L 1018 1036 L 1031 1033 L 1045 1025 Q 1058 1015 1062 996 L 1062 897 L 1059 883 L 1052 870 Q 1042 856 1023 851 Q 1017 853 1016 850 L 925 850 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1096"
          d="M 1265.5 804 L 1367.5 804 L 1368.5 805 L 1375.5 805 L 1385.5 807 Q 1416.5 816 1434 838.5 Q 1443.3 849.2 1449 863.5 L 1455 887.5 L 1455 998.5 Q 1448.1 1040.1 1420.5 1061 L 1397.5 1075 L 1385.5 1079 L 1369.5 1082 L 1263.5 1082 L 1243.5 1078 L 1223.5 1069 Q 1208.6 1059.9 1198 1046.5 Q 1182.8 1028.7 1178 1000.5 L 1178 885.5 Q 1185.3 845.3 1212.5 825 Q 1223.6 815.6 1238.5 810 L 1251.5 806 L 1264.5 805 L 1265.5 804 Z M 1271 850 L 1256 853 L 1242 861 Q 1228 871 1224 892 L 1224 995 Q 1226 1009 1234 1018 L 1246 1028 L 1256 1033 L 1269 1036 L 1365 1036 L 1378 1033 L 1393 1024 Q 1405 1014 1409 995 L 1409 893 Q 1406 876 1397 867 Q 1387 855 1371 851 Q 1364 853 1363 850 L 1271 850 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1097"
          d="M 1612.5 804 L 1713.5 804 L 1714.5 805 L 1722.5 805 Q 1758.2 812.3 1778 835.5 Q 1795.3 853.7 1801 883.5 Q 1799.2 889.7 1802 891.5 L 1802 994.5 L 1798 1015.5 L 1789 1035.5 Q 1781 1049 1769.5 1059 Q 1751.9 1075.4 1723.5 1081 Q 1717.3 1079.3 1715.5 1082 L 1610.5 1082 L 1593.5 1079 L 1570.5 1069 Q 1557 1061 1547 1049.5 Q 1530.5 1031.5 1525 1002.5 Q 1526.5 997 1524 995.5 L 1524 890.5 L 1528 870.5 L 1537 850.5 Q 1544.6 837.6 1555.5 828 Q 1567 817.5 1582.5 811 L 1598.5 806 L 1611.5 805 L 1612.5 804 Z M 1618 850 L 1603 853 L 1590 860 L 1576 876 L 1571 889 Q 1573 894 1570 896 L 1570 991 L 1574 1007 L 1580 1017 L 1596 1030 L 1605 1034 L 1615 1036 L 1712 1036 L 1727 1032 L 1737 1026 L 1750 1011 L 1754 1001 L 1756 990 L 1756 897 L 1753 883 L 1746 870 Q 1736 856 1717 851 Q 1711 853 1710 850 L 1618 850 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1098"
          d="M 914.5 1138 L 1025.5 1138 Q 1026.8 1140.3 1031.5 1139 Q 1067.6 1147.4 1087 1172.5 Q 1101.8 1189.7 1107 1216.5 L 1107 1224.5 L 1108 1225.5 L 1108 1326.5 L 1107 1327.5 L 1107 1334.5 L 1105 1344.5 L 1096 1366.5 Q 1086.6 1382.6 1072.5 1394 Q 1054.7 1409.2 1026.5 1414 L 913.5 1414 Q 876.3 1407.3 856 1383.5 Q 846.4 1373.1 840 1359.5 L 836 1349.5 L 832 1331.5 L 832 1220.5 Q 838.4 1182.4 862.5 1162 Q 872.9 1152.4 886.5 1146 L 896.5 1142 L 914.5 1138 Z M 920 1184 Q 905 1186 897 1194 Q 882 1205 878 1226 L 878 1328 Q 880 1341 887 1350 Q 898 1364 919 1369 L 1022 1369 Q 1034 1367 1043 1360 Q 1057 1349 1062 1329 L 1062 1225 L 1058 1212 L 1049 1198 L 1032 1187 L 1021 1184 L 920 1184 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1099"
          d="M 1260.5 1138 L 1372.5 1138 Q 1373.7 1140.3 1378.5 1139 Q 1412.9 1146.6 1432 1169.5 Q 1441.6 1180.4 1448 1194.5 L 1453 1209.5 L 1455 1220.5 L 1455 1330.5 Q 1447.8 1372.8 1419.5 1394 Q 1402.8 1407.8 1377.5 1413 Q 1371.2 1411.3 1369.5 1414 L 1262.5 1414 L 1261.5 1413 L 1250.5 1412 L 1235.5 1407 Q 1217 1399 1204 1385.5 Q 1183.9 1366.1 1178 1332.5 L 1178 1219.5 Q 1185 1180.5 1210.5 1160 Q 1220.9 1150.9 1234.5 1145 L 1245.5 1141 L 1260.5 1138 Z M 1266 1184 Q 1252 1186 1244 1193 Q 1229 1204 1224 1225 L 1224 1329 Q 1227 1341 1233 1350 Q 1244 1364 1265 1369 L 1369 1369 Q 1381 1366 1390 1360 Q 1405 1349 1409 1328 L 1409 1226 Q 1407 1212 1400 1204 Q 1389 1188 1368 1184 L 1266 1184 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1100"
          d="M 1606.5 1138 L 1719.5 1138 Q 1720.7 1140.3 1725.5 1139 Q 1761.6 1147.4 1781 1172.5 Q 1796 1189.5 1801 1216.5 Q 1799.2 1222.8 1802 1224.5 L 1802 1326.5 L 1798 1347.5 L 1792 1362.5 Q 1783.1 1379.1 1769.5 1391 Q 1752 1407.5 1723.5 1413 Q 1718 1411.5 1716.5 1414 L 1609.5 1414 L 1593.5 1411 L 1575.5 1404 Q 1558.9 1395.1 1547 1381.5 Q 1536.4 1369.6 1530 1353.5 L 1525 1334.5 Q 1526.5 1329 1524 1327.5 L 1524 1224.5 L 1527 1207.5 L 1536 1185.5 Q 1545.4 1169.4 1559.5 1158 Q 1570 1149.5 1583.5 1144 L 1606.5 1138 Z M 1612 1184 Q 1597 1187 1588 1195 L 1577 1208 L 1572 1219 L 1570 1229 L 1570 1325 L 1573 1338 L 1581 1352 Q 1591 1365 1612 1369 L 1715 1369 Q 1729 1366 1739 1358 L 1749 1346 L 1754 1335 L 1756 1324 L 1756 1230 L 1753 1216 L 1745 1202 Q 1734 1188 1715 1184 L 1612 1184 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1101"
          d="M 920.5 1469 L 1021.5 1469 L 1022.5 1470 L 1030.5 1470 L 1043.5 1473 L 1058.5 1479 Q 1075.9 1488.1 1088 1502.5 Q 1097.1 1512.9 1103 1526.5 L 1106 1534.5 L 1110 1553.5 L 1110 1662.5 L 1106 1681.5 L 1098 1699.5 Q 1089 1715 1075.5 1726 L 1052.5 1740 L 1044.5 1743 L 1024.5 1747 L 917.5 1747 L 901.5 1744 L 883.5 1737 Q 866.3 1727.7 854 1713.5 L 840 1691.5 L 836 1681.5 L 832 1663.5 L 832 1552.5 Q 838.9 1511.9 865.5 1491 L 885.5 1478 L 898.5 1473 L 920.5 1469 Z M 918 1516 Q 903 1519 894 1528 Q 882 1539 878 1558 L 878 1660 Q 881 1674 889 1684 Q 900 1697 922 1701 L 1019 1701 L 1036 1696 L 1044 1691 Q 1057 1680 1062 1661 L 1062 1562 L 1059 1548 L 1052 1535 Q 1042 1521 1023 1516 L 918 1516 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1102"
          d="M 1266.5 1469 L 1365.5 1469 L 1366.5 1470 L 1380.5 1471 Q 1415 1479.5 1434 1503.5 Q 1443.1 1514.4 1449 1528.5 L 1455 1552.5 L 1455 1663.5 Q 1447.8 1705.8 1419.5 1727 L 1397.5 1740 L 1389.5 1743 L 1370.5 1747 L 1262.5 1747 L 1261.5 1746 L 1250.5 1745 L 1235.5 1740 Q 1217 1732 1204 1718.5 Q 1183.9 1699.1 1178 1665.5 L 1178 1550.5 Q 1185.3 1510.3 1212.5 1490 Q 1223.6 1480.6 1238.5 1475 L 1252.5 1471 L 1265.5 1470 L 1266.5 1469 Z M 1264 1516 Q 1249 1519 1241 1527 Q 1228 1537 1224 1557 L 1224 1660 Q 1226 1674 1234 1683 Q 1241 1691 1251 1696 L 1268 1701 L 1366 1701 L 1378 1698 L 1392 1690 Q 1405 1679 1409 1660 L 1409 1558 Q 1406 1541 1397 1532 Q 1387 1520 1370 1516 L 1264 1516 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_1103"
          d="M 1613.5 1469 L 1712.5 1469 L 1713.5 1470 L 1727.5 1471 Q 1759.5 1479 1778 1500.5 Q 1795.3 1518.7 1801 1548.5 Q 1799.2 1554.7 1802 1556.5 L 1802 1659.5 L 1798 1680.5 L 1792 1695.5 Q 1783.1 1712.1 1769.5 1724 Q 1752 1740.5 1723.5 1746 Q 1718 1744.5 1716.5 1747 L 1609.5 1747 L 1593.5 1744 L 1575.5 1737 Q 1558.9 1728.1 1547 1714.5 Q 1530.3 1696.7 1525 1667.5 Q 1526.5 1662 1524 1660.5 L 1524 1555.5 L 1525 1554.5 L 1526 1543.5 L 1531 1527.5 Q 1539.7 1507.7 1554.5 1494 Q 1566.3 1482.8 1582.5 1476 L 1598.5 1471 L 1612.5 1470 L 1613.5 1469 Z M 1610 1516 Q 1597 1519 1589 1526 Q 1580 1533 1575 1543 L 1570 1561 L 1570 1656 L 1574 1672 L 1579 1681 Q 1590 1697 1614 1701 L 1712 1701 L 1722 1699 L 1736 1692 L 1750 1676 L 1754 1666 L 1756 1656 L 1756 1562 L 1753 1548 L 1746 1535 Q 1736 1521 1717 1516 L 1610 1516 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'PhoneSecond')

export default icon
